"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferReminderTemplatesContract = void 0;
/* eslint-disable perfectionist/sort-objects */
const core_1 = require("@ts-rest/core");
const schemas_1 = require("../../../../schemas");
const offer_reminders_request_1 = require("./offer-reminders.request");
const offer_reminders_response_1 = require("./offer-reminders.response");
const c = (0, core_1.initContract)();
exports.OfferReminderTemplatesContract = c.router({
    create: {
        method: 'POST',
        path: '/',
        body: offer_reminders_request_1.OfferReminderTemplateCreateRequestSchema,
        responses: {
            201: offer_reminders_response_1.OfferReminderTemplateResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    findMany: {
        method: 'GET',
        path: '/',
        query: offer_reminders_request_1.OfferReminderTemplateListQuerySchema,
        responses: {
            200: offer_reminders_response_1.OfferReminderTemplateListResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
        },
    },
    findById: {
        method: 'GET',
        path: '/:templateId',
        pathParams: offer_reminders_request_1.OfferReminderTemplateIdPathParamsSchema,
        responses: {
            200: offer_reminders_response_1.OfferReminderTemplateResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    update: {
        method: 'PATCH',
        path: '/:templateId',
        pathParams: offer_reminders_request_1.OfferReminderTemplateIdPathParamsSchema,
        body: offer_reminders_request_1.OfferReminderTemplateUpdateRequestSchema,
        responses: {
            200: offer_reminders_response_1.OfferReminderTemplateResponseSchema,
            400: schemas_1.BaseErrorResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
    delete: {
        method: 'DELETE',
        path: '/:templateId',
        pathParams: offer_reminders_request_1.OfferReminderTemplateIdPathParamsSchema,
        responses: {
            200: schemas_1.BaseResponseSchema,
            401: schemas_1.BaseErrorResponseSchema,
            404: schemas_1.BaseErrorResponseSchema,
        },
    },
}, { pathPrefix: '/offer-reminders' });
